/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as QrCode } from '../../assets/svg/qr-code.svg';
export default QrCode;
